import type { Migration, MigrationRun } from './api/migrationsClient';

type WithRuns = Pick<Migration, 'lastApply' | 'lastDryRun'>;

/** Who started a run: their email, which every run records. */
export const runnerName = (run: MigrationRun) => run.startedBy?.email || 'Unknown';

/** The newer of the last real run and the last dry run. */
export const lastRunOf = (m: WithRuns): MigrationRun | null => {
  const runs = [m.lastApply, m.lastDryRun].filter((r): r is MigrationRun => !!r);
  if (runs.length === 0) return null;
  return runs.reduce((a, b) => ((a.startedAt ?? '') >= (b.startedAt ?? '') ? a : b));
};
